
import {
    Box,
    useStyleConfig,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    IconButton
} from "@chakra-ui/react";
import { FaEllipsisV } from 'react-icons/fa';


function Card({ data, svgRef, ...props }) {
    const { variant, children, ...rest } = props;
    const styles = useStyleConfig("Card", { variant });

    const handleDownloadSVG = () => {
        // Implement SVG download logic here
        if (!svgRef.current) return;

        // Serialize SVG
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svgRef.current);

        // Create a data URL
        const blob = new Blob([svgString], { type: "image/svg+xml" });
        const url = URL.createObjectURL(blob);

        // Create a temporary download anchor element
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = "downloaded.svg";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        // Clean up by revoking the Object URL
        URL.revokeObjectURL(url);
    };

    const convertToTSV = (data) => {
        // Create the header
    
        const headers = Object.keys(data[0]);

        const tsvHeader = headers.join("\t");

        // Convert data to TSV rows
        const tsvRows = data.map(d => [d.name, d.value].join("\t"));

        // Combine the header and rows
        return [tsvHeader, ...tsvRows].join("\n");
    };

    const downloadTSV = (filename, tsvData) => {
        const blob = new Blob([tsvData], { type: "text/tsv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
    };


    const handleDownloadTable = () => {
        // Implement table download logic here
        const tsvData = convertToTSV(data);
        downloadTSV("data.tsv", tsvData);
    };

    return (
        <Box position="relative" __css={styles} {...rest}>
            {children}

            {/* Ellipsis Menu */}
            <Menu>
                <MenuButton
                    as={IconButton}
                    aria-label="Options"
                    icon={<FaEllipsisV />}
                    bg="white" // This sets the background to a specific shade of grey
                    color="gray.400" // This sets the icon color to white
                    _hover={{ bg: "gray.300" }}  // Optional: Darkens the button a bit on hover

                    variant="unstyled"
                    position="absolute"
                    top="5px"
                    right="5px"
                />
                <MenuList>
                    <MenuItem onClick={handleDownloadSVG}>Download SVG</MenuItem>
                    <MenuItem onClick={handleDownloadTable}>Download Table</MenuItem>
                    {/* Add more options as needed */}
                </MenuList>
            </Menu>
        </Box>
    );
}

export default Card;
